import { render, staticRenderFns } from "./ProfilesView.vue?vue&type=template&id=4340eaf4"
import script from "./ProfilesView.vue?vue&type=script&lang=js"
export * from "./ProfilesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports